module.exports = __webpack_public_path__ + "static/img/emotions1_10.b7e437a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/emotions/images/emotions1_10.png
// module id = ZSZB
// module chunks = 0